import React, { memo } from "react";
import TextField from "@mui/material/TextField";
import { Box, InputAdornment, Typography } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent"; // Import the missing PercentIcon//+


const InputComponenet = ({
  label,
  placeholder,
  type,
  name,
  value,
  onChange,
  error,
  touched,
  onBlur,

  icon,
  className,
  defaultValue,

  subTitle,
  isDisable = false,
  isFloat = true,
  readOnly = false,
}: any) => {
  const handleInput = (event: any) => {
    if (type === "number") {
      // Get the input value
      const inputValue = event.target.value;
      // Validate and remove leading '-' if present
      let sanitizedValue = inputValue.replace(/^-/, "");
      sanitizedValue = inputValue.replace(isFloat ? /[^0-9.]/g : /[^0-9]/g, "");

      // Allow only one dot in the input
      const dotsCount = sanitizedValue.split(".").length - 1;
      if (dotsCount > 1) {
        sanitizedValue = sanitizedValue.slice(0, sanitizedValue.length - 1);
      }

      // Update the input value without the leading '-'
      event.target.value = sanitizedValue;
    }
  };

  return (
    <Box className={className}  >
      <Box className="label-flex" pb={2}>      <label className={className}>{label}</label>
        {subTitle && (
          <Typography
            variant="body2"
            gutterBottom
            color="text.secondary"
            sx={{ marginTop: "12px", paddingLeft: "3px" }}
          >
            ({subTitle})
          </Typography>
        )}
      </Box>
      <TextField
      sx={{
        "&:hover fieldset": {
          borderColor: "#741374", // Hover border color change
        },
        "& .MuiOutlinedInput-root": {
          "&:hover": {
            borderColor: "#741374", // Hover border color change

          },
          "&.Mui-focused fieldset": {
            borderColor: "741374", // Focus border color change
          },
        },
        "& input::selection": {
          backgroundColor: "741374", // Text selection background
        },
        pointerEvents: readOnly ? "none" : "auto", // Set pointer-events based on readOnly prop

      }}
        // sx={{
        // }}
        placeholder={placeholder}
        type={type === "number" ? "text" : type}
        key={name}
        name={name}
        id={name}
        data-testid={name}
        disabled={isDisable ?? false}
        autoComplete={type === "password" ? "current-password" : "off"}
        value={value ?? defaultValue}
        onBlur={onBlur && onBlur}
        onChange={onChange}
        onInput={handleInput}
        error={Boolean(error)} // Set error prop based on the presence of an error
        // helperText={
        //   touched && error ? (typeof error === "string" ? error : touched) : ""
        // }
        // className={`input-field ${touched && !value && "error"}`}
        // error={Boolean(error) && name !== "contactNumber"}
        helperText={
          touched && error ? (typeof error === "string" ? error : touched) : ""
        }
        // className={`input-field ${
        //   touched && !value && name !== "contactNumber" && "error"
        // }`}
        className={`${name} input-field ${isDisable ? "green-disabled-input" : "" // Apply the green-disabled-input class if disabled
          } ${touched && !value && name !== "contactNumber" && "error"}`}
        variant={isDisable ? "filled" : "outlined"}
        InputProps={{
          startAdornment: icon && (
            <InputAdornment position="start">
              {icon.isDollarSign ? (

                <AttachMoneyIcon fontSize="small" />
              ) : (
                <PercentIcon fontSize="small" />
              )}
            </InputAdornment>
          ),
          readOnly,
        }}
        fullWidth // This makes the input field take up the full width

      />
    </Box>
  );
};

export default memo(InputComponenet);
